'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 });
var e = require('../../_virtual/_rollupPluginBabelHelpers.js'), r = require('react'),
  t = require('../../routing/config.js'), n = require('./ClientLink.js'),
  u = require('./redirects.js'), i = require('./useBasePathname.js'),
  a = require('./useBaseRouter.js');

function l(e) {
  return e && e.__esModule ? e : { default: e };
}

var o = l(r);
exports.default = function(l) {
  const c = t.receiveLocalePrefixConfig(null == l ? void 0 : l.localePrefix);

  function f(r, t) {
    return o.default.createElement(n.default, e.extends({ ref: t, localePrefix: c, defaultLocale: l.defaultLocale }, r));
  }

  const s = r.forwardRef(f);
  return s.displayName = 'Link', {
    Link: s, redirect: function(e) {
      for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++) t[n - 1] = arguments[n];
      return u.clientRedirect({ pathname: e, localePrefix: c }, ...t);
    }, permanentRedirect: function(e) {
      for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++) t[n - 1] = arguments[n];
      return u.clientPermanentRedirect({ pathname: e, localePrefix: c }, ...t);
    }, usePathname: function() {
      return i.default(c);
    }, useRouter: function() {
      return a.default(c);
    },
  };
};
